// extracted by mini-css-extract-plugin
export default {"appContainer":"AppFrame__appContainer____w42S","footer":"AppFrame__footer___EtQPk"};